import { useEffect, useRef, useState } from 'react';

export const useCurrentTime = (secInterval: number) => {
    /** helpers */
    const getCurrentTime = () => {
        return new Date().toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
    };
    /** helpers */

    /** state, refs */
    const timerRef = useRef<any>(null);
    const [time, setTime] = useState(getCurrentTime());
    /** state, refs */

    /** effects */
    useEffect(() => {
        if (!timerRef.current) {
            timerRef.current = setInterval(() => {
                setTime(getCurrentTime());
            }, secInterval * 1000);
        }

        /** Cleanup */
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [secInterval]);
    /** effects */

    return time;
};

export const useInterval = (
    callback: () => void,
    delay: number | null,
    maxRetries?: number
) => {
    const savedCallback = useRef(callback);
    const [retriesRemaining, setRetriesRemaining] = useState(
        maxRetries || Infinity
    );

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
            setRetriesRemaining(prev => prev - 1);
        }
        if (
            delay !== null &&
            delay !== 0 &&
            retriesRemaining &&
            retriesRemaining > 0
        ) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay, retriesRemaining]);

    return { retriesRemaining };
};
